// Module
var code = "<h2 class=\"heading--isInteriorPageSubHeading\"> Contact Us</h2> ";
// Exports
export default code;